// extracted by mini-css-extract-plugin
module.exports = {"titleEditor":"style_titleEditor__8doI2","titleEditorMobile":"style_titleEditorMobile__ApHzh","titleInput":"style_titleInput__wLnzR"};